import { createNewDate } from '../../../Helpers/dates';
import { APPOINTMENT_TIME, RECALL_TIME } from './constants';

const APPOINTMENT_ACTIVITY_TYPE_ID = 4;

const buildTitle = (baseEntityFullName, entityFullName) => {
  if (baseEntityFullName === entityFullName) return baseEntityFullName ?? '';
  if (entityFullName && !baseEntityFullName) return entityFullName;
  return `${baseEntityFullName ?? ''} - ${entityFullName ?? ''}`.trim();
};

export const formatAppointment = ({
  id,
  entityId,
  scheduledOn,
  entityFullName,
  baseEntityFullName,
  createdByFullName,
  activityTypeId,
  notes,
  outcome,
  commercialCampaignId,
  assignee,
  remindBefore,
}) => {
  const startDate = createNewDate(scheduledOn);
  const isAppointment = activityTypeId === APPOINTMENT_ACTIVITY_TYPE_ID;
  const endDate = new Date(
    startDate.getTime() + (isAppointment ? APPOINTMENT_TIME : RECALL_TIME)
  );

  return {
    appointmentId: id,
    entityId,
    contactFullName: entityFullName,
    customerFullName: baseEntityFullName,
    createdByFullName,
    commercialCampaignId: commercialCampaignId ?? null,
    title: buildTitle(baseEntityFullName, entityFullName),
    type: isAppointment ? 'Appuntamento' : 'Recall',
    desc: notes,
    startDate,
    endDate,
    outcome,
    assignee,
    remindBefore,
  };
};

/**
 * Maps the raw appointment payload returned by `getEventsByperiod` into the
 * event shape consumed by react-big-calendar. Pure: no side effects.
 */
const formatAppointments = (data) =>
  Array.isArray(data) ? data.map(formatAppointment) : [];

export default formatAppointments;
